export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-12 md:px-6 md:grid-cols-12">
        <div className="md:col-span-5">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-serif text-xl font-black tracking-tight text-foreground-950">
              劲爆大瓜
            </span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            一份看得懂的热点地图：把年度、月度最值得知道的瓜料按热度、反转与影响整理成榜单，
            让你补课有据可查、看得明白。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            榜单内容仅作话题盘点用途，围绕公开讨论整理，不构成对任何个人或机构的定性与评价。
          </p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-sm font-bold text-foreground-950">栏目导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a className="text-foreground-600 hover:text-primary-600" href="#annual">年度大榜</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#monthly">月度瓜榜</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#hot">热瓜速览</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#deep">深度补课</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-sm font-bold text-foreground-950">热门圈层</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a className="text-foreground-600 hover:text-primary-600" href="#category">综艺热搜</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#category">选秀热榜</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#category">主播带货</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#category">商界瓜田</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm font-bold text-foreground-950">了解更多</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a className="text-foreground-600 hover:text-primary-600" href="#faq">常见问题</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#about">关于榜单</a></li>
            <li><a className="text-foreground-600 hover:text-primary-600" href="#subscribe">订阅榜单</a></li>
            <li>
              <a
                className="text-foreground-600 hover:text-primary-600"
                href="mailto:hello@jinbaodagua.example"
              >
                联系与线索反馈
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 劲爆大瓜排行榜 · 保留所有权利</p>
          <p className="flex items-center gap-2">
            专注于年度与月度话题热榜盘点
            <i className="ri-fire-fill text-primary-500"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}